import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const TermsOfService = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <div className="border-b border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="container mx-auto px-4 py-4 flex items-center gap-4">
          <Button variant="ghost" size="sm" onClick={() => navigate(-1)}>
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back
          </Button>
          <h1 className="text-xl font-bold">Terms of Service</h1>
        </div>
      </div>
      
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <Card>
          <CardHeader>
            <CardTitle>SocialBlast Terms of Service</CardTitle>
            <p className="text-sm text-muted-foreground">Last Updated: December 2025</p>
          </CardHeader>
          <CardContent className="prose prose-invert max-w-none space-y-6">
            <section>
              <h2 className="text-xl font-semibold mb-3">1. Acceptance of Terms</h2>
              <p className="text-muted-foreground">
                By accessing and using SocialBlast ("the Service"), you agree to be bound by these Terms of Service.
                If you do not agree to these terms, please do not use the Service.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-3">2. Description of Service</h2>
              <p className="text-muted-foreground">
                SocialBlast is a social media management platform that allows users to schedule and publish content
                across multiple social media platforms including Twitter, Telegram, Facebook, Instagram, and TikTok.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-3">3. User Responsibilities</h2>
              <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
                <li>You agree not to use the Service for any unlawful purposes.</li>
                <li>You are responsible for all content posted through your account.</li>
                <li>You must comply with the terms of service of connected social media platforms.</li>
              </ul>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-3">4. Third-Party Integrations</h2>
              <p className="text-muted-foreground">
                The Service integrates with third-party platforms (Twitter, TikTok, Facebook, etc.). 
                Your use of these integrations is subject to the respective platform's terms of service.
                We are not responsible for any changes or restrictions imposed by these third-party services.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-3">5. Content Guidelines</h2>
              <p className="text-muted-foreground">
                Users must not post content that is illegal, harmful, threatening, abusive, defamatory,
                or violates intellectual property rights. We reserve the right to remove any content
                that violates these guidelines.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-3">6. Limitation of Liability</h2>
              <p className="text-muted-foreground">
                The Service is provided "as is" without warranties of any kind. We shall not be liable
                for any indirect, incidental, special, consequential, or punitive damages resulting from
                your use of the Service.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-3">7. Modifications</h2>
              <p className="text-muted-foreground">
                We reserve the right to modify these Terms of Service at any time. Continued use of the
                Service after any such changes constitutes your acceptance of the new Terms of Service.
              </p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold mb-3">8. Contact</h2>
              <p className="text-muted-foreground">
                If you have any questions about these Terms of Service, please contact the platform administrator.
              </p>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default TermsOfService;
